export default "__VITE_ASSET__C0WTvI8y__"